export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ19.8b2eeb94.mp3";